import { render, staticRenderFns } from "./CustomersPage.vue?vue&type=template&id=62d2cf67&scoped=true"
import script from "./CustomersPage.vue?vue&type=script&lang=js"
export * from "./CustomersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d2cf67",
  null
  
)

export default component.exports